import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import ThroughputProfilesHelpModal from "./Help";
import ThroughputProfileSettingsHelpModal from "./SettingsHelp";
import { composedAPI } from "./api";
import throughputComposition from "./composition";

const ConfigThroughputProfiles = ({ ...settings }) => (
  <>
    <ProfilesAndSettings
      {...throughputComposition}
      {...composedAPI}
      {...settings}
    />
    <ThroughputProfilesHelpModal />
    <ThroughputProfileSettingsHelpModal />
  </>
);

export default ConfigThroughputProfiles;
